module.exports = __webpack_public_path__ + "./images/2e6cff28f6dab1c3e00ac64e2b50f8b9.webp";